export const getAuditMission = () => ({
  suffix: 'audit_missions',
  cachable: true,
})

export const getAuditMissionStats = () => ({
  suffix: 'audit_missions/statistics',
})
